import React, { useState, useEffect } from 'react';
import { faqAPI } from '../../../services/api';
import '../Shared/FormStyles.scss';

const FAQManager = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({
    question: '',
    answer: '',
    category: 'General',
    order: 0,
    isActive: true,
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchFAQs();
  }, []);

  const fetchFAQs = async () => {
    try {
      const response = await faqAPI.getAllAdmin();
      setFaqs(response.data);
    } catch (err) {
      setError('Failed to fetch FAQs');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      if (editing) {
        await faqAPI.update(editing._id, formData);
        setSuccess('FAQ updated successfully');
      } else {
        await faqAPI.create(formData);
        setSuccess('FAQ created successfully');
      }
      resetForm();
      fetchFAQs();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save FAQ');
    }
  };

  const handleEdit = (faq) => {
    setEditing(faq);
    setFormData({
      question: faq.question || '',
      answer: faq.answer || '',
      category: faq.category || 'General',
      order: faq.order || 0,
      isActive: faq.isActive !== undefined ? faq.isActive : true,
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this FAQ?')) return;
    try {
      await faqAPI.delete(id);
      setSuccess('FAQ deleted successfully');
      fetchFAQs();
    } catch (err) {
      setError('Failed to delete FAQ');
    }
  };

  const resetForm = () => {
    setEditing(null);
    setFormData({ question: '', answer: '', category: 'General', order: 0, isActive: true });
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="faq-manager">
      <div className="admin-form">
        <h2>{editing ? 'Edit FAQ' : 'Add New FAQ'}</h2>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Question *</label>
            <input
              type="text"
              value={formData.question}
              onChange={(e) => setFormData({ ...formData, question: e.target.value })}
              required
              placeholder="e.g. Do I need a referral?"
            />
          </div>
          <div className="form-group">
            <label>Answer *</label>
            <textarea
              value={formData.answer}
              onChange={(e) => setFormData({ ...formData, answer: e.target.value })}
              required
              rows={5}
              placeholder="Enter the answer..."
            />
          </div>
          <div className="form-group">
            <label>Category</label>
            <input
              type="text"
              value={formData.category}
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              placeholder="General"
            />
          </div>
          <div className="form-group">
            <label>Display Order</label>
            <input
              type="number"
              value={formData.order}
              onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) || 0 })}
              min="0"
            />
          </div>
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.isActive}
                onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
              />
              {' '}Active (visible on website)
            </label>
          </div>
          <div className="form-actions">
            <button type="submit" className="dashboard-btn btn-primary">
              {editing ? 'Update FAQ' : 'Create FAQ'}
            </button>
            {editing && (
              <button type="button" className="dashboard-btn btn-secondary" onClick={resetForm}>
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      <div className="data-table" style={{ marginTop: '30px' }}>
        <h2 style={{ padding: '20px', margin: 0 }}>All FAQs ({faqs.length})</h2>
        {faqs.length === 0 ? (
          <div className="empty-state">No FAQs yet. Add your first question above.</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Order</th>
                <th>Question</th>
                <th>Category</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {faqs.map((faq) => (
                <tr key={faq._id}>
                  <td>{faq.order}</td>
                  <td style={{ maxWidth: '300px' }}>{faq.question}</td>
                  <td>{faq.category}</td>
                  <td>{faq.isActive ? 'Active' : 'Inactive'}</td>
                  <td>
                    <div className="table-actions">
                      <button className="btn-edit" onClick={() => handleEdit(faq)}>Edit</button>
                      <button className="btn-delete" onClick={() => handleDelete(faq._id)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default FAQManager;
